var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ctyku6jc4a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    rx: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "qnwiz7gesc",
    width: 28,
    height: 20,
    x: 0,
    y: 0,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ez01yb9lif",
    width: 25,
    height: 25,
    x: 1,
    y: -3,
    rx: 12.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ctlulq2a4d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D81441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB0831"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o02vxbpn8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ctyku6jc4a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0.5,
    y: 0.5,
    stroke: "#EAEAEA",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#o02vxbpn8b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bxm0ij3rhe",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qnwiz7gesc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#qnwiz7gesc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 9.5,
    r: 5,
    fill: "url(#ctlulq2a4d)",
    mask: "url(#bxm0ij3rhe)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 1.5,
    y: -2.5,
    stroke: "#EAEAEA",
    rx: 12
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJp);
export default __webpack_public_path__ + "static/media/jp.c07fb27b5c2f1c1b83bf1bb45fa3eca7.svg";
export { ForwardRef as ReactComponent };